/**
 * The credits coin, as ajobthing draws it everywhere else.
 *
 * The same asset the host apps use — `icon/coin.vue` and both `LabelWithCoin`
 * components point at this URL, so the coin beside a reward in chat reads as
 * the coin the employer already knows from their credit balance. What was here
 * before was a hand-drawn disc with a `$` on it, which is neither ajobthing's
 * mark nor the right currency.
 *
 * Hotlinked rather than vendored, deliberately: a copy in this repo is a copy
 * that goes stale the day the asset is redrawn, and the host pages this app is
 * embedded in are already fetching it. `img-src` allows `https:`
 * (`security-headers.ts`), so no CSP change.
 *
 * Width is set from the asset's own 22:24 ratio rather than left to `auto`, so
 * the line does not reflow when the image lands.
 */
const COIN_SRC = 'https://files.ajobthing.com/assets/gamification/noto_coin.svg';

const RATIO = 22 / 24;

export function CoinIcon({ size = 14 }: { size?: number }) {
  return (
    <img
      src={COIN_SRC}
      alt=""
      aria-hidden="true"
      width={Math.round(size * RATIO)}
      height={size}
      // The reward line sets its own text baseline; without this the coin sits
      // on it and pushes the row taller than the label beside it.
      style={{ verticalAlign: 'text-bottom' }}
    />
  );
}
